<template>
  <nav v-if="numPages && numPages > 1">
    <ul class="mb-0 pagination justify-content-center pagination-sm">
      <li class="page-item" :class="{ disabled: curPage === 0 }">
        <span id="page-nav-prev-page" class="page-link cp" @click="pageUpdate(curPage-1)" data-tippy-content="previous page"><font-awesome-icon icon="caret-left"/></span>
      </li>
      
      <li
v-for="index in numPages" :key="index" 
        class="page-item"
        :class="{ active: curPage === index-1 }"
>
        <span class="page-link cp" @click="pageUpdate(index-1)" v-if="shouldRender(index-1)" :data-tippy-content="`page ${index}`">{{index}}</span>
      </li>

      <li class="page-item" :class="{ disabled: curPage === numPages -1 }">
        <span id="page-nav-next-page" class="page-link cp" @click="pageUpdate(curPage+1)" data-tippy-content="next page"><font-awesome-icon icon="caret-right"/></span>
      </li>
      
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import tippy from 'tippy.js';

interface Props {
  numPages?: number;
}

withDefaults(defineProps<Props>(), {
  numPages: 0
});

const emit = defineEmits<{
  'page-change': [index: number];
}>();

const curPage = ref(0);

onMounted(() => {
  tippy('[data-tippy-content]');
});

function pageUpdate(index: number) {
  curPage.value = index;
  emit('page-change', index);
}

function shouldRender(index: number): boolean {
  // we return the items available in between
  return Math.abs(index - curPage.value) <= 2;
}

function reset() {
  curPage.value = 0;
}

// Expose the reset function for template refs
defineExpose({
  reset
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/variables.scss" as *;

.page-link {
  color: $linkColourHover;
}

.page-item.active .page-link {
  background-color: $bgColour;
  border: 1px solid $bgColour;
  color: white !important;
}

.page-item.active .page-link:hover {
  background-color: $linkColour;
  border: 1px solid $linkColour;
}

</style>